module.exports = __webpack_public_path__ + "media/images/omniva-ca7f0a09.svg";